import { useState, useEffect } from 'react';
import axios from 'axios';

import { useBaseUrlContext } from '../context/Base_url';

export function useCreditData()  {

    const [creditResponse, setCreditResponse] = useState(null); 
    const [error, setError] = useState(null);  
    const { baseUrl } = useBaseUrlContext();

    useEffect(() => {

        const fetchCreditData = async () => {
            try{

                const header = {
                    'Authorization': localStorage.getItem('token')
                }
                
                const response = await axios.get(`${baseUrl}/dashboard/metrics`, {headers:header})
                console.log('res', response);
                setCreditResponse(response.data);
        
            } catch(error) {
                console.log('error', error)
                setError(error);
            }
        }

        fetchCreditData()

    },[])

    return { creditResponse, error };

}
